module.exports = __webpack_public_path__ + "img/logoMara.eb356a06.png";